import { z } from 'zod';
// CTSK-505 — `neighborhood.v1`: GET /documents/:id/neighborhood.
//
// One cheap, permission-safe answer to "what is related to this document?":
// the other live documents in the caller's org that share its ingest batch,
// source folder, group or collection. `neighborhood.v1` is the STABLE shape —
// later changes are additive only (new bases, new optional fields). Matching
// rules mirror the library list filters exactly (see docs/document-grouping.md):
//   group / collection  case-insensitive on the stored label (?group=, ?collection=)
//   folder              exact, case-sensitive, no subfolders (?folder=)
//   batch               id equality (?ingestBatch=)
export const NEIGHBORHOOD_SCHEMA = 'neighborhood.v1';
/** Order in which bases appear in the response. */
export const NEIGHBORHOOD_BASES = ['batch', 'folder', 'group', 'collection'];
export const NEIGHBORHOOD_LIMIT_DEFAULT = 50;
export const NEIGHBORHOOD_LIMIT_MAX = 100;
/** `count` is exact up to this value; beyond it `countCapped` is true. */
export const NEIGHBORHOOD_COUNT_CAP = 10_000;
export const NeighborhoodQuerySchema = z
    .object({
    limit: z.coerce
        .number()
        .int('limit must be an integer')
        .min(1, `limit must be between 1 and ${NEIGHBORHOOD_LIMIT_MAX}`)
        .max(NEIGHBORHOOD_LIMIT_MAX, `limit must be between 1 and ${NEIGHBORHOOD_LIMIT_MAX}`)
        .default(NEIGHBORHOOD_LIMIT_DEFAULT),
})
    .strip();
//# sourceMappingURL=neighborhood.js.map